/**
 * StoreFront Application Entry Point
 * Bootstraps the React application with Redux store and Router
 */

import * as React from 'react';
import { Provider } from 'react-redux';

import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import StoreFront from './index';
import { sfStore } from './store';

// Styles
import './styles/index.scss';

// Mount the application
const rootElement = document.getElementById('root');

if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <Provider store={sfStore}>
                <Router>
                    <StoreFront />
                </Router>
            </Provider>
        </React.StrictMode>,
    );
} else {
    console.error('Root element not found');
}
